import { render } from "./Share.vue?vue&type=template&id=304a6628"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"
script.render = render

export default script